import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import About from "./pages/About";
import Forex from "./pages/Forex";
import Indices from './pages/Indices';
import Commodities from'./pages/Commodity';
import Cryptocurrency from './pages/Cryptocurrency';
import Pc from './pages/Pc';
import Web from './pages/Web';
import Mobile from './pages/Mobile';
import Account from './pages/Account';
import Contact from './pages/Contact';
import Legal from './pages/Legal';

function App() {
  return (
    <Router>
    
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<About />} />
      <Route path="/forex" element={<Forex />} />
      <Route path="/indices" element={<Indices />} />
      <Route path="/commodity" element={<Commodities />} />
      <Route path="/cryptocurrency" element={<Cryptocurrency />} />
      <Route path="/GlobusPCTerminal" element={<Pc />} />
      <Route path="/GlobusWebTrader" element={<Web />} />
      <Route path="/GlobusMobileApp" element={<Mobile />} />
      <Route path="/account" element={<Account />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/legal" element={<Legal />} />

    </Routes>
  </Router>
  );
}

export default App;
